/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./AppTextarea.vue?vue&type=template&id=32049214"
import script from "./AppTextarea.ts?vue&type=script&lang=ts&external"
export * from "./AppTextarea.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports